<template>
  <div>
    <div class="ui top blue attached progress" id="progress_bar" v-if="progress_bar_flag">
      <div class="bar"></div>
    </div>
    <div class="ui error message" v-if="error_message_flag">
      <i class="close icon"></i>
      <div class="header">
        Ошибка
      </div>
      {{error_message_text}}
    </div>
    <div class="ui top attached tabular menu">
      <a class="item active" data-tab="first">Болезнь</a>
      <a class="item" data-tab="second">Прививка</a>
      <a class="item" data-tab="third">Медицинский отвод</a>
      <a class="item" data-tab="four">Горячая линия</a>
    </div>
    <div class="ui bottom attached tab segment active" data-tab="first">
      <div class="ui info message">
        <i class="close icon"></i>
        <div class="header">
          Если Вы заболели или перенесли COVID-19
        </div>
        <ul class="list">
          <li>Укажите данные о болезни</li>
          <li>Прикрепите подтверждающие документы о заболевании</li>
        </ul>
      </div>
      <div class="ui cards" v-if="analyzes.length != 0">
        <div class="card" v-for="(item, index) of analyzes">
          <div class="content">
            <div class="header">Анализ на COVID-19</div>
            <div class="meta">
              {{RepresentationDate(item.date_receipt)}}
            </div>
            <div class="description">
              <p><b>Тип анализа:</b> {{item.type_analyzes}}</p>
              <p><b>Результат:</b> {{item.result}}</p>
              <p><b>Статус:</b> {{item.status}}</p>
              <p><b>Файл:</b> Добавлен</p>
            </div>
          </div>
          <div class="ui bottom attached button"  v-on:click="EditAnalyze(index)">
            <i class="pencil icon"></i>
            Изменить
          </div>
        </div>
      </div>
      <div class="ui modal" id="analysis_modal">
        <i class="close icon"></i>
        <div class="header">
          Анализ на COVID-19
        </div>
        <div class="content">
          <div class="description">
            <form class="ui form" id="analysis_form">
              <div class="field">
                <label>Тип анализа</label>
                <select id="type_analyzes" class="ui dropdown" name="type_analyzes" v-model="analysis.type_analyzes">
                  <option v-for="option in options_type_analyzes" :value="option.id" :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="field">
                <label>Дата последнего посещения занятия/работы</label>
                <input type="date" name="date_last_session" v-model="analysis.date_last_session" >
              </div>
              <div class="field">
                <label>Дата сдачи анализа</label>
                <input type="date" name="date_receipt" v-model="analysis.date_receipt">
              </div>
              <div class="field">
                <label>Результат</label>
                <select id="result_analysis" class="ui dropdown" name="result" v-model="analysis.result">
                  <option v-for="option in options_result_analysis" :value="option.id" :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="field">
                <label>Телефон</label>
                <input type="text" name="cell_phone" v-model="analysis.cell_phone" v-mask="['+7 ###-##-##-###']">
              </div>
              <div class="field">
                <label>Скан заключения</label>
                <input type="file" name="file_analysis"  id="file_analysis" ref="file_analysis" v-on:change="FileUpload('analysis')">
              </div>
              <div class="ui error message"></div>
            </form>
          </div>
        </div>
        <div class="actions">
          <div class="ui gray deny button">
            Закрыть
          </div>
          <div class="ui positive inverted right labeled icon button" v-on:click="SubmitAnalysis()">
            Подтвердить
            <i class="checkmark icon"></i>
          </div>
        </div>
      </div>
     <button class="ui button positive" style="margin-top: 15px" v-on:click="AddAnalysis()">
       <i class="add icon"></i>
       Анализ
     </button>
     <div class="ui cards" style="margin-top: 12.25px" v-if="computed_tomography.length > 0">
        <div class="card" v-for="(item, index) of computed_tomography">
          <div class="content">
            <div class="header">Компьютерная томография</div>
            <div class="meta">
              {{RepresentationDate(item.date_receipt)}}
            </div>
            <div class="description">
              <p><b>Повреждение легких:</b> {{item.lung_damage}} %</p>
              <p><b>Статус:</b> {{item.status}}</p>
              <p><b>Файл:</b> Добавлен</p>
            </div>
          </div>
          <div class="ui bottom attached button"  v-on:click="EditCT(index)">
            <i class="pencil icon"></i>
            Изменить
          </div>
        </div>
      </div>
      <div class="ui modal" id="ct_modal">
        <i class="close icon"></i>
        <div class="header">
          Результат компьютерной томографии
        </div>
        <div class="content">
          <div class="description">
            <form class="ui form" id="ct_form">
              <div class="field">
                <label>Дата сдачи компьютерной томографии</label>
                <input type="date" name="date_receipt" v-model="tomography.date_receipt">
              </div>
              <div class="field">
                <label>Повреждение легких (%)</label>
                <input type="text" name="lung_damage" v-model="tomography.lung_damage">
              </div>
              <div class="field">
                <label>Скан заключения</label>
                <input type="file" name="file_ct"  id="file_ct" ref="file_ct" v-on:change="FileUpload('tomography')">
              </div>
              <div class="ui error message"></div>
            </form>
          </div>
        </div>
        <div class="actions">
          <div class="ui gray deny button">
            Закрыть
          </div>
          <div class="ui positive inverted right labeled icon button" v-on:click="SubmitCT()">
            Подтвердить
            <i class="checkmark icon"></i>
          </div>
        </div>
      </div>
      <button class="ui button positive" style="margin-top: 15px" v-on:click="AddCT()">
        <i class="add icon"></i>
        Компьютерная томография
      </button>
    </div>
    <div class="ui bottom attached tab segment" data-tab="second">
      <div class="ui info message">
        <i class="close icon"></i>
        <div class="header">
          Если Вы привились вакциной
        </div>
        <ul class="list">
          <li>Укажите данные вакцинации</li>
          <li>Прикрепите подтверждающие документы о вакцинации</li>
        </ul>
      </div>
      <div class="ui cards" v-if="grafts.length > 0">
        <div class="card" v-for="(item, index) of grafts">
          <div class="content">
            <div class="header">Прививка</div>
            <div class="meta">
              {{RepresentationDate(item.date_receipt)}}
            </div>
            <div class="description">
              <p><b>Вакцина:</b> {{item.vaccine}}</p>
              <p><b>Статус:</b> {{item.status}}</p>
              <p><b>Файл:</b> Добавлен</p>
            </div>
          </div>
          <div class="ui bottom attached button"  v-on:click="EditGraft(index)">
            <i class="pencil icon"></i>
            Изменить
          </div>
        </div>
      </div>
      <div class="ui modal" id="graft_modal">
        <i class="close icon"></i>
        <div class="header">
          Вакцина
        </div>
        <div class="content">
          <div class="description">
            <form class="ui form" id="graft_form">
              <div class="field">
                <label>Дата получения</label>
                <input type="date" name="date_receipt" v-model="graft.date_receipt">
              </div>
              <div class="field">
                <label>Вакцина</label>
                <select id="vaccine_graft" class="ui dropdown" name="vaccine" v-model="graft.vaccine" v-on:change="changeM()">
                  <option v-for="option in options_vaccine_graft" :value="option.id" :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="field">
                <label>Этап вакцинации (фаза)</label>
                <!--select class="ui color dropdown" name="phase" v-model="graft.phase"-->
                <!--select :class="[dropdown_class, { disabled: disable }]" name="phase" v-model="graft.phase"-->
                <!--select v-bind:class="disable ? 'enabled' : 'disabled'" name="phase" v-model="graft.phase"-->
                <select id="phase_graft" class="ui dropdown" v-bind:class="{'color': disable}" name="phase" v-model="graft.phase">
                  <option v-for="option in options_phase_graft" :value="option.id" :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="field">
                <label>Скан подтверждения</label>
                <input type="file" name="file_graft" id="file_graft" ref="file_graft" v-on:change="FileUpload('graft')">
              </div>
              <div class="ui error message"></div>
            </form>
          </div>
        </div>
        <div class="actions">
          <div class="ui gray deny button">
            Закрыть
          </div>
          <div class="ui positive inverted right labeled icon button" v-on:click="SubmitGraft()">
            Подтвердить
            <i class="checkmark icon"></i>
          </div>
        </div>
      </div>
      <button class="ui button positive" style="margin-top: 15px" v-on:click="AddGraft()">
        <i class="add icon"></i>
        Прививка
      </button>
    </div>
    <div class="ui bottom attached tab segment" data-tab="third">
      <div class="ui info message">
        <i class="close icon"></i>
        <div class="header">
          Если у Вас есть противопоказания к вакцинации.
        </div>
        <ul class="list">
          <li>Добавьте мед. отвод, заверенный лицензированной медицинской организацией.</li>
          <li>Добавьте добровольный отказ. Форму отказа от профилактических прививок, необходимо <a href="/refused_covid19_pdf" target="_blank">скачать</a>, заполнить и добавть. (В соответствии со ст. 5 п. 3 ФЗ РФ № 157 от 17.09.1998 г.)</li>
        </ul>
      </div>
      <div class="ui cards" v-if="medical_withdrawal.length > 0">
        <div class="card" v-for="(item, index) of medical_withdrawal">
          <div class="content">
            <div class="header">Медицинский отвод</div>
            <div class="meta">
              {{RepresentationDate(item.date_receipt)}}
            </div>
            <div class="description">
              <p><b>Период:</b> {{item.period}}</p>
              <p><b>Причина:</b> {{item.reason}}</p>
              <p><b>Статус:</b> {{item.status}}</p>
              <p><b>Файл:</b> Добавлен</p>
            </div>
          </div>
          <div class="ui bottom attached button"  v-on:click="EditWithdrawal(index)">
            <i class="pencil icon"></i>
            Изменить
          </div>
        </div>
      </div>
      <div class="ui modal" id="withdrawal_modal">
        <i class="close icon"></i>
        <div class="header">
          Медицинский отвод
        </div>
        <div class="content">
          <div class="description">
            <form class="ui form" id="withdrawal_form">
              <div class="field">
                <label>Дата получения мед. отвовда</label>
                <input type="date" name="date_receipt" v-model="withdrawal.date_receipt">
              </div>
              <div class="field">
                <label>Период действия</label>
                <select id="withdrawal_period" class="ui dropdown" name="period" v-model="withdrawal.period">
                  <option v-for="option in options_withdrawal_period" :value="option.id" :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="field">
                <label>Причина</label>
                <select id="withdrawal_reason" class="ui dropdown" name="reason" v-model="withdrawal.reason">
                  <option v-for="option in options_withdrawal_reason" :value="option.id" :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="field">
                <label>Медицинская организация</label>
                <!--select id="withdrawal_medical_organization" class="ui dropdown" name="medical_organization" v-model="withdrawal.medical_organization">
                  <option v-for="option in options_withdrawal_medical_organization" :value="option.id" :key="option.id">
                    {{ option.text }}
                  </option>
                </select-->
                <input id="withdrawal_medical_organization" type="text" name="medical_organization" v-model="withdrawal.medical_organization">
              </div>
              <div class="field">
                <label>Иные пометки</label>
                <textarea rows="2" v-model="withdrawal.other"></textarea>
              </div>
              <div class="field">
                <label>Скан мед. отвовда</label>
                <input type="file" name="file_withdrawal" id="file_withdrawal" ref="file_withdrawal" v-on:change="FileUpload('withdrawal')">
              </div>
              <div class="ui error message"></div>
            </form>
          </div>
        </div>
        <div class="actions">
          <div class="ui gray deny button">
            Закрыть
          </div>
          <div class="ui positive inverted right labeled icon button" v-on:click="SubmitWithdrawal()">
            Подтвердить
            <i class="checkmark icon"></i>
          </div>
        </div>
      </div>
      <button class="ui button positive" style="margin-top: 15px" v-on:click="AddWithdrawal()">
        <i class="add icon"></i>
        Медицинский отвод
      </button>

      <div class="ui cards" style="margin-top: 12.25px" v-if="refusals.length > 0">
        <div class="card" v-for="(item, index) of refusals">
          <div class="content">
            <div class="header">Отказ</div>
            <div class="meta">
              {{RepresentationDate(item.date_receipt)}}
            </div>
            <div class="description">
              <p><b>Статус:</b> {{item.status}}</p>
              <p><b>Файл:</b> Добавлен</p>
            </div>
          </div>
          <div class="ui bottom attached button"  v-on:click="EditRefusal(index)">
            <i class="pencil icon"></i>
            Изменить
          </div>
        </div>
      </div>
      <div class="ui modal" id="refusal_modal">
        <i class="close icon"></i>
        <div class="header">
          Отказ
        </div>
        <div class="content">
          <div class="description">
            <form class="ui form" id="refusal_form">
              <div class="field">
                <label>Дата отказа</label>
                <input type="date" name="date_receipt" v-model="refusal.date_receipt">
              </div>
              <div class="field">
                <label>Иные пометки</label>
                <textarea rows="2" v-model="refusal.other"></textarea>
              </div>
              <div class="field">
                <label>Скан отказа</label>
                <input type="file" name="file_refusal"  id="file_refusal" ref="file_refusal" v-on:change="FileUpload('refusal')">
              </div>
              <div class="ui error message"></div>
            </form>
          </div>
        </div>
        <div class="actions">
          <div class="ui gray deny button">
            Закрыть
          </div>
          <div class="ui positive inverted right labeled icon button" v-on:click="SubmitRefusal()">
            Подтвердить
            <i class="checkmark icon"></i>
          </div>
        </div>
      </div>
      <button class="ui button positive" style="margin-top: 15px" v-on:click="AddRefusal()">
        <i class="add icon"></i>
        Отказ
      </button>
    </div>
    <div class="ui bottom attached tab segment" data-tab="four">
      <div class="ui info message">
        <i class="close icon"></i>
        <div class="header">
          Связитесь с нами по номеру телефона или через e-mail.
        </div>
        <ul class="list">
          <li>Тел.: +7 (4162) 234-516. Отдел гражданской обороны. Пн.—Пт. с 8:00—17:00. Обед: 12:00—13:00.</li>
          <li>E-mail: gochs@amursu.ru, vakulenko.on@amursu.ru</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash';

export default {
  name: "covid_19",
  data: () => ({
    type_submit: 0,
    disable: false,
    enabled: 'ui dropdown',
    disabled: 'ui color dropdown',
    progress_bar_flag: false,
    error_message_flag: false,
    error_message_text: "",
    file: '',
    errors: [],
    analyzes: [],
    computed_tomography: [],
    grafts: [],
    medical_withdrawal:[],
    refusals: [],
    analysis: {
      type_analyzes: '',
      date_last_session: '',
      date_receipt: '',
      result: '',
      cell_phone: '',
      status: '',
    },
    tomography:{
      date_receipt: '',
      lung_damage: 0,
      type_pneumonia: '',
      status: '',
    },
    graft: {
      date_receipt: '',
      vaccine: '',
      phase: '',
      status: '',
    },
    withdrawal:{
      date_receipt: '',
      reason: '',
      period: '',
      medical_organization: '',
      other: '',
      status: '',
    },
    refusal:{
      date_receipt: '',
      other: '',
      status: '',
    },
    options_type_analyzes: [
      {id: "ПЦР", text: "ПЦР"},
      {id: "Антитела", text: "Антитела"}
    ],
    options_result_analysis: [
      {id: "Отрицательный", text: "Отрицательный"},
      {id: "Положительный", text: "Положительный"}
    ],
    options_vaccine_graft: [
      {id: "Гам-Ковид-Вак (Спутник V)", text: "Гам-Ковид-Вак (Спутник V)"},
      {id: "Гам-Ковид-Вак (Спутник lite)", text: "Гам-Ковид-Вак (Спутник lite)"},
      {id: "ЭпиВакКорона", text: "ЭпиВакКорона"},
      {id: "КовиВак", text: "КовиВак"},
      {id: "Иная", text: "Иная"},
    ],
    options_phase_graft: [
      {id: "I этап", text: "I этап"},
      {id: "II этап", text: "II этап"},
    ],
    options_withdrawal_period: [
      {id: "Временый", text: "Временый"},
      {id: "Постоянный", text: "Постоянный"},
    ],
    options_withdrawal_reason: [
      {id: "Отказ", text: "Отказ"},
      {id: "Перенесенный COVID-19", text: "Перенесенный COVID-19"},
      {id: "Хронические заболевания", text: "Хронические заболевания"},
      {id: "Беременность и период лактации", text: "Беременность и период лактации"},
      {id: "Аллергия", text: "Аллергия"},
      {id: "Гиперчувствительность к какому-либо компоненту вакцины", text: "Гиперчувствительность к какому-либо компоненту вакцины"},
      {id: "ОРВИ", text: "ОРВИ"},
      {id: "Возраст до 18 лет", text: "Возраст до 18 лет"},
    ],
    options_withdrawal_medical_organization: [
      {id: "Амурская областная клиническая больница", text: "Амурская областная клиническая больница"},
      {id: "Благовещенская городская клиническая больница", text: "Благовещенская городская клиническая больница"},
      {id: "Амурская областная детская клиническая больница", text: "Амурская областная детская клиническая больница"},
      {id: "Детская городская клиническая больница", text: "Детская городская клиническая больница"},
      {id: "Городская поликлиника №1", text: "Городская поликлиника №1"},
      {id: "Городская поликлиника №2", text: "Городская поликлиника №2"},
      {id: "Городская поликлиника №3", text: "Городская поликлиника №3"},
      {id: "Городская поликлиника №4", text: "Городская поликлиника №4"},
      {id: "Лечебно-диагностический центр", text: "Лечебно-диагностический центр"},
      {id: "-", text: "-"},
    ],
  }),
  mounted() {
    this.LoadAnalyzes();
    this.LoadCT();
    this.LoadGraft();
    this.LoadWithdrawal();
    this.LoadRefusal();

    /*document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        var elem = document.getElementById("ui-datepicker-div");
        elem.parentElement.removeChild(elem);
      }
    },*/
    $('#analysis_form')
      .form({
        fields: {
          type_analyzes: {
            identifier: 'type_analyzes',
            rules: [
              {
                type   : 'empty',
                prompt : 'Укажите тип'
              }
            ]
          },
          date_last_session: {
            identifier: 'date_last_session',
            rules: [
              {
                type   : 'empty',
                prompt : 'Укажите дату посещения занятия/работы'
              }
            ]
          },
          date_receipt: {
            identifier: 'date_receipt',
            rules: [
              {
                type   : 'empty',
                prompt : 'Укажите дату сдачи анализа'
              }
            ]
          },
          result: {
            identifier: 'result',
            rules: [
              {
                type   : 'empty',
                prompt : 'Укажите вакцину'
              }
            ]
          },
          cell_phone: {
            identifier: 'cell_phone',
            rules: [
              {
                type   : 'empty',
                prompt : 'Укажите телефон'
              }
            ]
          },
          file_analysis: {
            identifier: 'file_analysis',
            rules: [
              {
                type   : 'empty',
                prompt : 'Прикрепите файл'
              },
              {
                type   : 'regExp',
                value  : '/^(.*.((pdf|jpg|jpeg)$))?[^.]*$/i',
                prompt : 'Тип файла должен быть *.pdf, *.jpg или *.jpeg',

              },
            ]
          },
        }
      });
    $('#ct_form')
      .form({
        fields: {
          date_receipt: {
            identifier: 'date_receipt',
            rules: [
              {
                type   : 'empty',
                prompt : 'Укажите дату'
              }
            ]
          },
          lung_damage: {
            identifier: 'lung_damage',
            rules: [
              {
                type   : 'empty',
                prompt : 'Укажите дату'
              }
            ]
          },
          file_ct: {
            identifier: 'file_ct',
            rules: [
              {
                type   : 'empty',
                prompt : 'Прикрепите файл'
              },
              {
                type   : 'regExp',
                value  : '/^(.*.((pdf|jpg|jpeg)$))?[^.]*$/i',
                prompt : 'Тип файла должен быть *.pdf, *.jpg или *.jpeg',

              },
            ]
          },
        }
      });
    $('#graft_form')
      .form({
        fields: {
          date_receipt: {
            identifier: 'date_receipt',
            rules: [
              {
                type   : 'empty',
                prompt : 'Укажите дату'
              }
            ]
          },
          vaccine: {
            identifier: 'vaccine',
            rules: [
              {
                type   : 'empty',
                prompt : 'Укажите вакцину'
              }
            ]
          },
          file_graft: {
            identifier: 'file_graft',
            rules: [
              {
                type   : 'empty',
                prompt : 'Прикрепите файл'
              },
              {
                type   : 'regExp',
                value  : '/^(.*.((pdf|jpg|jpeg)$))?[^.]*$/i',
                prompt : 'Тип файла должен быть *.pdf, *.jpg или *.jpeg',

              },
            ]
          },
        }
      });
    $('#withdrawal_form')
      .form({
        fields: {
          date_receipt: {
            identifier: 'date_receipt',
            rules: [
              {
                type   : 'empty',
                prompt : 'Укажите дату'
              }
            ]
          },
          period: {
            identifier: 'period',
            rules: [
              {
                type   : 'empty',
                prompt : 'Укажите период'
              }
            ]
          },
          reason: {
            identifier: 'reason',
                rules: [
              {
                type   : 'empty',
                prompt : 'Укажите причину'
              }
            ]
          },
          /*medical_organization: {
            identifier: 'medical_organization',
                rules: [
              {
                type   : 'empty',
                prompt : 'Укажите медицинскую организацию'
              }
            ]
          },*/
          file_withdrawal: {
            identifier: 'file_withdrawal',
                rules: [
              {
                type   : 'empty',
                prompt : 'Прикрепите файл'
              },
              {
                type   : 'regExp',
                value  : '/^(.*.((pdf|jpg|jpeg)$))?[^.]*$/i',
                prompt : 'Тип файла должен быть *.pdf, *.jpg или *.jpeg',

              },
              /*{
                type   : 'regExp',
                value.size : '',
                prompt : 'Размер файла не должен привышать 2 мб'
              }*/
            ]
          },
        }
      });
      $('#refusal_form')
        .form({
          fields: {
            date_receipt: {
              identifier: 'date_receipt',
              rules: [
                {
                  type   : 'empty',
                  prompt : 'Укажите дату'
                }
              ]
            },
            file_refusal: {
              identifier: 'file_refusal',
              rules: [
                {
                  type   : 'empty',
                  prompt : 'Прикрепите файл'
                },
                {
                  type   : 'regExp',
                  value  : '/^(.*.((pdf|jpg|jpeg)$))?[^.]*$/i',
                  prompt : 'Тип файла должен быть *.pdf, *.jpg или *.jpeg',

                },
              ]
            },
          }
      });
  },
  computed: {},
  watch: {
    /*'graft.vaccine': function (newValue, oldValue){
      console.log(newValue)
      console.log('newValue == "Гам-Ковид-Вак (Спутник V)" || newValue == "ЭпиВакКорона"')
      console.log(newValue == "Гам-Ковид-Вак (Спутник V)" || newValue == "ЭпиВакКорона")
      this.disable =  (newValue == "Гам-Ковид-Вак (Спутник V)" || newValue == "ЭпиВакКорона");

      /!*if(newValue == "Гам-Ковид-Вак (Спутник V)" || newValue == "ЭпиВакКорона"){
        this.disable = true;
        this.disable = true;
        console.log("Отключают disabled")
      }else{
        this.disable = false;
        console.log("Включает disabled")
      }*!/
    }*/
  },
  methods: {
    changeM: function(){
      console.log(this.graft.vaccine)
      //this.disable =  (this.graft.vaccine == "Гам-Ковид-Вак (Спутник V)" || this.graft.vaccine == "ЭпиВакКорона");
      this.disable = !this.disable;
      console.log(this.disable)
    },
    RepresentationDate: function(date){
      if(date != "" && date != undefined){
        return `${date.substring(8, 10)}.${date.substring(5, 7)}.${date.substring(0, 4)}`
      }else{
        return ""
      }
    },
    FileUpload: function(kind){
      switch (kind) {
        case 'analysis':
          this.file = this.$refs.file_analysis.files[0];
          break;
        case 'tomography':
          this.file = this.$refs.file_ct.files[0];
          break;
        case 'graft':
          this.file = this.$refs.file_graft.files[0];
          break;
        case 'withdrawal':
          this.file = this.$refs.file_withdrawal.files[0];
          break;
        case 'refusal':
          this.file = this.$refs.file_refusal.files[0];
          break;
        default:
      }
    },
    SubmitFile: function(kind, ref_doc){
      let formData = new FormData();
      formData.append('reference_name', ref_doc.reference_name);
      formData.append('reference_id', ref_doc.reference_id);
      formData.append('reference_uid', ref_doc.reference_uid);
      formData.append('reference_class_name', ref_doc.reference_class_name);
      formData.append('file', this.file);
      const token = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;

      axios({
        method: 'post',
        url: '/push_file',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData
      }).then( (response) => {
        if(response.data.reference_id != "error"){
          $('#progress_bar').progress({percent: 100});
          this.progress_bar_flag = false;
          switch (kind) {
            case 'analysis':
              this.LoadAnalyzes();
              break;
            case 'tomography':
              this.LoadCT();
              break;
            case 'graft':
              this.LoadGraft();
              break;
            case 'withdrawal':
              this.LoadWithdrawal();
              break;
            case 'refusal':
              this.LoadRefusal();
              break;
            default:
          }
          this.file = '';
        }else{
          this.error_message_flag = true
          this.error_message_text = "Не удалось сохранить файл"
        }
        return response;
      }).catch((error) => {
        return error;
      });
    },

    //Analyzes
    LoadAnalyzes(){
      axios({
        method: 'get',
        url: '/load_analyzes',
      }).then((response) => {
        if(response.data.analysis){
          if(!Array.isArray(response.data.analysis)){
            this.analyzes = []
            this.analyzes.push(response.data.analysis);
          }else{
            this.analyzes = response.data.analysis;
          }
        }/*else{
          this.error_message_flag = true
          this.error_message_text = "Не удалось загрузить список анализов"
        }*/
        return response;
      }).catch((error) => {
        return error;
      });
    },
    AddAnalysis: function(){
      this.type_submit = 1;
      $('#analysis_modal').modal({closable: false,
        onDeny: () => {
          this.ClearFormAnalysis();
          return true;
        },
        onApprove: () => {
          this.progress_bar_flag = true;
          return $('#analysis_form').form('is valid');
        }
      }).modal('show');
    },
    SubmitAnalysis: function(){
      $('#analysis_form').form('validate form');
      if($('#analysis_form').form('is valid')){
        $('#progress_bar').progress({percent: 35});
        if(this.type_submit){
          this.AppealTo1c('push_analysis',this.analysis ,'анализ','analysis');
        }else{
          this.AppealTo1c('edit_analysis',this.analysis ,'анализ','analysis');
        }
      }
    },
    EditAnalyze: function(index){
      this.type_submit = 0;
      this.analysis = _.cloneDeep(this.analyzes[index]);
      $('#result_analysis').val(this.analysis.result).change();
      $('#type_analyzes').val(this.analysis.type_analyzes).change();
      $('#analysis_modal').modal({closable: false,
        onDeny: () => {
          this.ClearFormAnalysis();
          return true;
        },
        onApprove: () => {
          this.progress_bar_flag = true;
          return $('#analysis_form').form('is valid');
        }
      }).modal('show');
    },
    DeleteAnalysis: function(index){
      this.analyzes.splice(index,1);
    },
    ClearFormAnalysis: function(){
      document.getElementById('analysis_form').reset();
      $('#result_analysis').dropdown('restore defaults');
      $('#type_analyzes').dropdown('restore defaults');
      this.type_submit = 0;
      this.analysis = _.cloneDeep({
        type_analyzes: '',
        date_last_session: '',
        date_receipt: '',
        result: '',
        cell_phone: '',
        status: '',
      });
    },


    //ComputedTomography
    LoadCT(){
      axios({
        method: 'get',
        url: '/load_computed_tomography',
      }).then((response) => {
        if(response.data.tomography){
          if(!Array.isArray(response.data.tomography)){
            this.computed_tomography = []
            this.computed_tomography.push(response.data.tomography);
          }else{
            this.computed_tomography = response.data.tomography;
          }
        }/*else{
          this.error_message_flag = true
          this.error_message_text = "Не удалось загрузить список компьютерных томографий"
        }*/
        return response;
      }).catch((error) => {
        return error;
      });
    },
    AddCT: function(){
      this.type_submit = 1;
      $('#ct_modal').modal({closable: false,
        onDeny: () => {
          this.ClearFormCT();
          return true;
        },
        onApprove: () => {
          this.progress_bar_flag = true;
          return $('#ct_form').form('is valid');
        }
      }).modal('show');
    },
    SubmitCT: function(){
      $('#ct_form').form('validate form');
      if($('#ct_form').form('is valid')){
        if(this.type_submit){
          this.AppealTo1c('push_computed_tomography',this.tomography ,'компьютерную томографию','tomography');
        }else{
          this.AppealTo1c('edit_computed_tomography',this.tomography ,'компьютерную томографию','tomography');
        }
      }
    },
    EditCT: function(index){
      this.type_submit = 0;
      this.tomography = _.cloneDeep(this.computed_tomography[index]);
      $('#ct_modal').modal({closable: false,
        onDeny: () => {
          this.ClearFormCT();
          return true;
        },
        onApprove: function(){
          this.progress_bar_flag = true;
          return $('#ct_modal').form('is valid');
        }
      }).modal('show');
    },
    DeleteCT: function(index){
      this.computed_tomography.splice(index,1);
    },
    ClearFormCT: function(){
      document.getElementById('ct_form').reset();
      this.type_submit = 0;
      this.tomography = _.cloneDeep({
        date_receipt: '',
        lung_damage: 0,
        type_pneumonia: '',
        status: '',
      });
    },

    //Graft
    LoadGraft(){
      axios({
        method: 'get',
        url: '/load_grafts',
      }).then((response) => {
        if(response.data.graft){
          if(!Array.isArray(response.data.graft)){
            this.grafts = []
            this.grafts.push(response.data.graft);
          }else{
            this.grafts = response.data.graft;
          }
        }/*else{
          this.error_message_flag = true
          this.error_message_text = "Не удалось загрузить список прививок"
        }*/
        return response;
      }).catch((error) => {
        return error;
      });
    },
    AddGraft: function(){
      this.type_submit = 1;
      $('#graft_modal').modal({closable: false,
        onDeny: () => {
          this.ClearFormGraft();
          return true;
        },
        onApprove: () => {
          this.progress_bar_flag = true;
          return $('#graft_form').form('is valid');
        }
      }).modal('show');
    },
    SubmitGraft: function(){
      $('#graft_form').form('validate form');
      if($('#graft_form').form('is valid')){
        if(this.type_submit){
          this.AppealTo1c('push_graft',this.graft ,'прививку','graft');
        }else{
          this.AppealTo1c('edit_graft',this.graft ,'прививку','graft');
        }
      }
    },
    EditGraft: function(index){
      this.type_submit = 0;
      this.graft = _.cloneDeep(this.grafts[index]);
      $('#vaccine_graft').val(this.graft.vaccine).change();
      $('#phase_graft').val(this.graft.phase).change();
      $('#graft_modal').modal({closable: false,
        onDeny: () => {
          this.ClearFormGraft();
          return true;
        },
        onApprove: () => {
          this.progress_bar_flag = true;
          return $('#graft_form').form('is valid');
        }
      }).modal('show');
    },
    DeleteGraft: function(index){
    },
    ClearFormGraft: function(){
      document.getElementById('graft_form').reset();
      $('#vaccine_graft').dropdown('restore defaults');
      $('#phase_graft').dropdown('restore defaults');
      this.type_submit = 0;
      this.graft = _.cloneDeep({
        date_receipt: '',
        vaccine: '',
        phase: '',
        status: '',
      });
    },

    //Withdrawal
    LoadWithdrawal(){
      axios({
        method: 'get',
        url: '/load_medical_withdrawal',
      }).then((response) => {
        if(response.data.withdrawal){
          if(!Array.isArray(response.data.withdrawal)){
            this.medical_withdrawal  = []
            this.medical_withdrawal.push(response.data.withdrawal);
          }else{
            this.medical_withdrawal = response.data.withdrawal;
          }
        }/*else{
          this.error_message_flag = true
          this.error_message_text = "Не удалось загрузить список мед. отвод"
        }*/
        return response;
      }).catch((error) => {
        return error;
      });
    },
    AddWithdrawal: function(){
      this.type_submit = 1;
      $('#withdrawal_modal').modal({closable: false,
        onDeny: () => {
          this.ClearFormWithdrawal();
          return true;
        },
        onApprove: () => {
          this.progress_bar_flag = true;
          return $('#withdrawal_form').form('is valid');
        }
      }).modal('show');
    },
    SubmitWithdrawal: function(){
      $('#withdrawal_form').form('validate form');
      if($('#withdrawal_form').form('is valid')){
        if(this.type_submit){
          this.AppealTo1c('push_medical_withdrawal',this.withdrawal,'мед. отвеод','withdrawal');
        }else{
          this.AppealTo1c('edit_medical_withdrawal',this.withdrawal,'мед. отвеод','withdrawal');
        }
      }
    },
    EditWithdrawal: function(index){
      this.type_submit = 0;
      this.withdrawal = _.cloneDeep(this.medical_withdrawal[index]);
      $('#withdrawal_period').val(this.withdrawal.period).change();
      $('#withdrawal_reason').val(this.withdrawal.reason).change();
      $('#withdrawal_medical_organization').val(this.withdrawal.medical_organization).change();
      $('#withdrawal_modal').modal({closable: false,
        onDeny: () => {
          this.ClearFormWithdrawal();
          return true;
        },
        onApprove: () => {
          this.progress_bar_flag = true;
          return $('#withdrawal_form').form('is valid');
        }
      }).modal('show');
    },
    DeleteWithdrawal: function(index){
    },
    ClearFormWithdrawal: function(){
      document.getElementById('withdrawal_form').reset();
      $('#withdrawal_period').dropdown('restore defaults');
      $('#withdrawal_reason').dropdown('restore defaults');
      $('#withdrawal_medical_organization').dropdown('restore defaults');
      this.withdrawal = _.cloneDeep({
        date_receipt: '',
        reason: '',
        period: '',
        medical_organization: '',
        other: '',
        status: '',
      });
    },

    //Refusal
    LoadRefusal: function(){
      axios({
        method: 'get',
        url: '/load_refusals',
      }).then((response) => {
        if(response.data.refusal){
          if(!Array.isArray(response.data.refusal)){
            this.refusals = []
            this.refusals.push(response.data.refusal);
          }else{
            this.refusals = response.data.refusal;
          }
        }/*else{
          this.error_message_flag = true
          this.error_message_text = "Не удалось загрузить список анализов"
        }*/
        return response;
      }).catch((error) => {
        return error;
      });
    },
    AddRefusal: function(){
      this.type_submit = 1;
      $('#refusal_modal').modal({closable: false,
        onDeny: () => {
          this.ClearFormRefusal();
          return true;
        },
        onApprove: () => {
          this.progress_bar_flag = true;
          return $('#refusal_form').form('is valid');
        }
      }).modal('show');
    },
    SubmitRefusal: function() {
      $('#refusal_form').form('validate form');
      if($('#refusal_form').form('is valid')){
        if(this.type_submit){
          this.AppealTo1c('push_refusal',this.refusal ,'отказ','refusal');
        }else{
          this.AppealTo1c('edit_refusal',this.refusal ,'отказ','refusal');
        }
      }
    },
    EditRefusal: function(index){
      this.type_submit = 0;
      this.refusal = _.cloneDeep(this.refusals[index]);
      $('#refusal_modal').modal({closable: false,
        onDeny: () => {
          this.ClearFormRefusal();
          return true;
        },
        onApprove: () => {
          this.progress_bar_flag = true;
          return $('#refusal_form').form('is valid');
        }
      }).modal('show');
    },
    DeleteRefusal: function(index){
    },
    ClearFormRefusal: function(){
      this.refusal = _.cloneDeep({
        date_receipt: '',
        other: '',
        status: '',
      });
    },
    AppealTo1c: function(path,data,message,kind){
      const token = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;

      axios({
        method: 'post',
        url: `${path}`,
        data: {data: data}
      }).then((response) => {
        if(response.data.reference_id != "error"){
          this.SubmitFile(kind, response.data);
           $('#progress_bar').progress({percent: 70});
          switch (kind) {
            case 'analysis':
              this.ClearFormAnalysis();
              break;
            case 'tomography':
              this.ClearFormCT()
              break;
            case 'graft':
              this.ClearFormGraft();
              break;
            case 'withdrawal':
              this.ClearFormWithdrawal();
              break;
            case 'refusal':
              this.ClearFormRefusal();
              break;
            default:
          }
        }else{
          this.error_message_flag = true
          this.error_message_text = `Не удалось сохранить ${message}`
          this.progress_bar_flag = false;
        }
        return response;
      }).catch((error) => {
        return error;
      });
    },

  },
}
</script>

<style>
.color {
  background: #e80000 !important;
}
</style>